import { createFrontendPlugin } from '@backstage/frontend-plugin-api';
import { topicKafkaContent } from './TopicKafkaContent';
import { serviceKafkaContent } from './ServiceKafkaContent';

export const kafkaPlugin = createFrontendPlugin({
  pluginId: 'kafka',
  extensions: [topicKafkaContent, serviceKafkaContent],
});
